import React from "react";
import { useLocation, Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = () => {
  const location = useLocation();
  const paths = location.pathname.split("/").filter(Boolean);

  const breadcrumbItems = [
    { label: "Home", path: "/admin" },
    ...paths.slice(1).map((path, index) => ({
      label: path.charAt(0).toUpperCase() + path.slice(1).replace("-", " "),
      path: "/" + paths.slice(0, index + 2).join("/"),
    })),
  ];

  return (
    <nav className="flex items-center gap-2 px-6 py-3 bg-gray-50 border-b border-gray-200 text-sm">
      {breadcrumbItems.map((item, index) => (
        <React.Fragment key={item.path}>
          {index > 0 && <ChevronRight size={16} className="text-gray-400" />}
          {index === breadcrumbItems.length - 1 ? (
            <span className="text-gray-600 font-medium">{item.label}</span>
          ) : (
            <Link
              to={item.path}
              className="text-blue-600 hover:text-blue-800 hover:underline"
            >
              {item.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};
